export const MAIN_FORM_AREA = 'mainFormArea';
export const BASKET_AREA = 'basketArea';
